var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("EventListingsController", [
    "$scope", "$rootScope", "$location", "eventsService",
    function ($scope, $rootScope, $location, eventsService) {
        $scope.eventBannerimgPath = window.__env.digitalEventImgBaseUrl;
        $scope.getDigitalEvents = function () {
            eventsService.getDigitalEvents().then(
                function (response) {
                    if (response && response.data) {
                        $scope.events = response.data;
                    }
                }
            );
        }
        $scope.getDigitalEvents();
    },
]);
